export enum TwoFactorStatus {
  ACTIVE = 'active',
  INITIAL = 'initial',
  INACTIVE = 'inactive',
  ERROR = 'error',
}
